export const PART_STATUS = {
  NOT_QUOTED: "NOT_QUOTED",
  QUOTED: "QUOTED",
  READY_FOR_PROD: "READY_FOR_PROD",
  PRODUCTION: "PRODUCTION",
};

export const PART_LABELER = (name) =>
  name
    ?.toLowerCase()
    ?.split("_")
    ?.map((w) => w[0].toUpperCase() + w.slice(1))
    ?.join(" ");

export const PART_STATUS_OPTIONS = Object.values(PART_STATUS)?.map((stat) => ({
  id: stat,
  label: PART_LABELER(stat),
}));

export const PART_STATUSES = [
  { id: 4, label: "Inactive", flow: "red" },
  { id: 3, label: "Not Quoted", flow: "red" },
  { id: 2, label: "Unverified", flow: "grey" },
  { id: 5, label: "Reviewed", flow: "blue" },
  { id: 1, label: "Verified", flow: "green" },
];
